








import Vue from 'vue';
import {MetaInfo} from 'vue-meta';

import BackToTheTopButton from '@/components/layout/BackToTheTopButton.vue';
import SocialSharing from '@/components/layout/SocialSharing.vue';
import meta from '@/meta';


export default Vue.extend({
  name: 'app',
  components: {
    BackToTheTopButton,
    SocialSharing,
  },
  metaInfo: <MetaInfo> {
    meta,
  },
});
